"use client";

import React, { useState } from 'react';
import { Sidebar, Badge } from 'flowbite-react';
import { HiArrowSmRight, HiChartPie, HiInbox, HiOutlineViewBoards, HiShoppingBag, HiTable, HiUser, HiViewBoards } from 'react-icons/hi';
import { BiBuoy } from 'react-icons/bi';
import { useNavigate } from 'react-router-dom';  // Use React Router's navigation
import Modal from 'react-modal'; // Import React Modal
import Login from './Login'; // Import Login component
import './Sidebar.css'

const SidebarComponent = () => {
  const navigate = useNavigate(); // Use the navigate hook for redirection
  const [isModalOpen, setIsModalOpen] = useState(false); // State to control modal visibility

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <div className="sidebar-container">
      <Sidebar aria-label="Custom sidebar example">
        {/* Sidebar with a Logo */}
        <Sidebar.Logo href="https://www.learnbotix.com/" img="android-chrome-512x512.png" imgAlt="Learnbotix">
          Learnbotix
        </Sidebar.Logo>

        <Sidebar.Items>
          <Sidebar.ItemGroup>
            <Sidebar.Item href="/dashboard" icon={HiChartPie}>
              Dashboard
            </Sidebar.Item>

            {/* Multi-level Dropdown */}
            {/*
            <Sidebar.Collapse icon={HiShoppingBag} label="Knowledge Store">
              <Sidebar.Item href="/products">Open Source</Sidebar.Item>
              <Sidebar.Item href="/sales">Tier1</Sidebar.Item>
              <Sidebar.Item href="/refunds">Tier2</Sidebar.Item>
              <Sidebar.Item href="/shipping">Tier3</Sidebar.Item>
            </Sidebar.Collapse>
            */}

            <Sidebar.Item onClick={() => navigate('/knowledge-store')} icon={HiShoppingBag}>
              Knowledge Store
            </Sidebar.Item>

            <Sidebar.Collapse icon={HiInbox} label="Chat History">
              <Sidebar.Item href="/products">Message 1</Sidebar.Item>
              <Sidebar.Item href="/sales">Message 2</Sidebar.Item>
              <Sidebar.Item href="/refunds">Message 3</Sidebar.Item>
              <Sidebar.Item href="/shipping">Message 4</Sidebar.Item>
            </Sidebar.Collapse>

            <Sidebar.Item href="/users" icon={HiUser} label="3">
              Users
            </Sidebar.Item>
            <Sidebar.Item onClick={() => navigate('/')} icon={HiViewBoards}>
              Chat
            </Sidebar.Item>
            {/*
            <Sidebar.Item onClick={() => navigate('/storage')} icon={HiTable}>
              My Cloud Storage
            </Sidebar.Item> 
            */}
            <Sidebar.Item onClick={() => navigate('/cloud-storage')} icon={HiViewBoards}>
              My Cloud Storage
            </Sidebar.Item>
            <Sidebar.Item onClick={() => navigate('/knowledge-pack')} icon={HiViewBoards}>
              Knowledge Packs
            </Sidebar.Item>

            <Sidebar.Item href="/VS" icon={HiOutlineViewBoards}>
              Vector Store
            </Sidebar.Item>

            {/* Sign In and Sign Up with Modal */}
            <Sidebar.Item onClick={openModal} icon={HiArrowSmRight}>
              Sign In
            </Sidebar.Item>
            {/*
            <Sidebar.Item onClick={() => navigate('/signup')} icon={HiTable}>
              Sign Up
            </Sidebar.Item>
            */}
          </Sidebar.ItemGroup>

          {/* Content Separator */}
          <Sidebar.ItemGroup>
            <Sidebar.Item href="/upgrade" icon={HiChartPie}>
              Upgrade to Pro
            </Sidebar.Item>
            <Sidebar.Item href="/docs" icon={HiViewBoards}>
              Documentation
            </Sidebar.Item>
            <Sidebar.Item href="/help" icon={BiBuoy}>
              Help
            </Sidebar.Item>
          </Sidebar.ItemGroup>
        </Sidebar.Items>

        {/* Call-to-Action Button */}
        <Sidebar.CTA>
          <div className="mb-3 flex items-center">
            <Badge color="warning">Beta</Badge>
            <button
              aria-label="Close"
              className="-m-1.5 ml-auto inline-flex h-6 w-6 rounded-lg bg-gray-100 p-1 text-cyan-900 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-400 dark:hover:bg-gray-600"
              type="button"
            >
              <svg
                aria-hidden
                className="h-4 w-4"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          </div>
          <div className="mb-3 text-sm text-cyan-900 dark:text-gray-400">
            Preview the new Learnbotix knowledge store! New features coming soon!
          </div>
          <a
            className="text-sm text-cyan-900 underline hover:text-cyan-800 dark:text-gray-400 dark:hover:text-gray-300"
            href="https://www.learnbotix.com/"
          >
            Click here to learn more!
          </a>
        </Sidebar.CTA>
      </Sidebar>

      {/* Modal for Login */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Sign In Modal"
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: '400px',
          }
        }}
      >
        <button onClick={closeModal} style={{ float: 'right' }}>Close</button>
        <Login /> {/* Render the Login component inside the modal */}
      </Modal>
    </div>
  );
};

export default SidebarComponent;


